import { Controller } from "@hotwired/stimulus"
import { articleVideoEmbed, articleSocialEmbed } from "../lib/article_video"

export default class extends Controller {
  connect() {
    this.frames = []
    this.resizeObserver = new ResizeObserver(() => {
      clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(() => this.resizeFacebookFrames(), 150)
    })
    this.element.querySelectorAll("figure.post-video, figure.post-social").forEach((figure) => {
      const social = figure.classList.contains("post-social")
      const link = figure.querySelector(social ? "a.post-social__source" : "a.post-video__source")
      const src = link && (social ? articleSocialEmbed(link.href) : articleVideoEmbed(link.href))
      if (!src || figure.querySelector("iframe")) return

      const ratio = figure.className.match(/\bpost-video-ratio-(\d{1,4})-(\d{1,4})\b/)
      const width = Number(ratio?.[1]) || 560
      const height = Number(ratio?.[2]) || 315
      if (width < 100 || height < 100 || height / width > 3) return

      const frame = document.createElement("iframe")
      const embedUrl = new URL(src)
      if (embedUrl.hostname === "www.facebook.com" && figure.clientWidth > 0) {
        embedUrl.searchParams.set("width", String(Math.floor(figure.clientWidth)))
      }
      frame.src = embedUrl.toString()
      frame.title = link.title || (social ? "Bài đăng Facebook" : "Video biểu diễn")
      frame.loading = "lazy"
      frame.allow = "encrypted-media; fullscreen; picture-in-picture"
      frame.allowFullscreen = true
      frame.referrerPolicy = "strict-origin-when-cross-origin"
      frame.style.width = "100%"
      if (social) frame.style.height = "680px"
      else frame.style.aspectRatio = `${width} / ${height}`
      frame.style.border = "0"
      frame.className = "post-video__frame"
      figure.prepend(frame)
      this.frames.push(frame)
      this.resizeObserver.observe(figure)
    })
  }

  disconnect() {
    this.resizeObserver?.disconnect()
    clearTimeout(this.resizeTimer)
    this.frames?.forEach((frame) => frame.remove())
  }

  resizeFacebookFrames() {
    this.frames.forEach((frame) => {
      const url = new URL(frame.src)
      const width = Math.floor(frame.getBoundingClientRect().width)
      if (url.hostname !== "www.facebook.com" || !width || url.searchParams.get("width") === String(width)) return
      url.searchParams.set("width", String(width))
      frame.src = url.toString()
    })
  }
}
